/*global YT*/

let YTplayer;

window.onYouTubeIframeAPIReady = () => {

    YTplayer = new YT.Player("ytplayer", {
        playerVars: {
            "showinfo": 1,
            "iv_load_policy": 3,
            "modestbranding": 1,
            "rel": 0,
            "color": "white"
        }
    });
};

$(document).ready(function() {

    const btnOpen = (".js-open-modal[data-modal=video]"),
        $btnClose = $(".js-close-modal");

    //открытие модального окна с видео YouTube
    $(document).on("click", btnOpen,  function(){

        let video = $(this).data("video");

        YTplayer.loadVideoById(video);
        YTplayer.playVideo();
    });

    //закрытие модального окна с видео YouTube
    $btnClose.each(function(){

        if($(this).parents(".js-modal").data("modal") == "video"){

            $(this).on("click", () => {
                YTplayer.pauseVideo();
            });
        }
    });
});

